/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef, useState } from 'react';
import Webcam from 'react-webcam';

import './photoMake.scss';

import { Svg } from '../svg/svg';

type PhotoMakeProps = {
	onCreate: (val: string) => void;
	sellfy?: boolean;
};

export function PhotoMake({ onCreate, sellfy }: PhotoMakeProps) {
	const [facingMode, setFacingMode] = useState<any>(sellfy ? 'user' : { exact: 'environment' });
	const webcamRef = useRef<Webcam>(null);

	const handlePhoto = () => {
		const imageSrc = webcamRef.current?.getScreenshot();
		if (imageSrc) onCreate(imageSrc);
	};

	const handleFacing = () => {
		setFacingMode((old: any) => (old === 'user' ? { exact: 'environment' } : 'user'));
	};

	// videoConstraints={{ facingMode: 'environment' }}

	return (
		<div className="photo-make">
			<Webcam
				ref={webcamRef}
				audio={false}
				// height={720}
				screenshotFormat="image/jpeg"
				// width={1280}
				videoConstraints={{ facingMode: facingMode }}
			/>
			<div className="photo-make__buttons">
				<button className="btn" onClick={handleFacing}>
					<Svg name="camera" />
				</button>
				<button className="btn btn--primery" onClick={handlePhoto}>
					Сделать фото
				</button>
			</div>
		</div>
	);
}
